






















import { Component, Vue } from 'vue-property-decorator';

@Component
export default class DragAndDropOverlay extends Vue {

  isOver: boolean = false;


  onDragEnter(e: any) {
    if (e.fromElement === null && e.relatedTarget !== null) {
      this.showOverlay();
    }
  }
  onDragLeave(e: any) {
    if (e.relatedTarget === null) {
      this.hideOverlay(null);
    }
  }
  onDrop(e: any) {
    e.preventDefault();
    this.hideOverlay(null);
  }
  showOverlay() {
    this.isOver = true;
  }
  hideOverlay(e: any) {
    this.isOver = false;
  }

  mounted() {
    window.addEventListener('dragenter', this.onDragEnter);
    window.addEventListener('dragleave', this.onDragLeave);

    const overlay = this.$refs.overlay as any;
    overlay.addEventListener('dragover', (e: any) => {
      e.preventDefault();
    });
    overlay.addEventListener('drop', this.onDrop);
  }
  beforeDestroy() {
    window.removeEventListener('dragenter', this.onDragEnter);
    window.removeEventListener('dragleave', this.onDragLeave);

    const overlay = this.$refs.overlay as any;
    overlay.removeEventListener('dragover', (e: any) => {
      e.preventDefault();
    });
    overlay.removeEventListener('drop', this.onDrop);
  }
}
